import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, OutlookIntegrationsResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof OutlookIntegrationsResponseDataSchema>>

const queryKey = ["outlookIntegrations"]

export const outlookIntegrationsQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/outlook`)

      return response.data.data
    },
  })
}
